import { FC, ReactNode } from 'react';

import cn from '@/utils/cn';

interface Props {
  className?: string;
  children: ReactNode;
}

const SummaryWrapper: FC<Props> = ({ className, children }) => {
  return (
    <section
      className={cn(
        ' flex max-w-[980px] flex-col gap-x-2.5 gap-y-5 rounded-lg border-t-[6px] border-blue-600 bg-gray-100 px-3.5 py-4 lg:grid lg:grid-cols-2 lg:gap-x-5 lg:gap-y-[30px] lg:rounded-[10px] lg:p-10',
        className
      )}
    >
      {children}
    </section>
  );
};

export default SummaryWrapper;
